var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useContext, useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { NationalAccountContext } from '../../../../../contexts';
import { modalBlurbs, nationalAccountRegex, shared, } from '../../../../../constants/NationalAccount';
import { handleMultiLines, ReturnError, ShowSpinner, ToolTip, ModalButtonGroup, } from '../commons';
import { TextField } from '../../../../shared/text-field/text-field';
import { clickCta } from '../../../../../utils/analytics';
export var CodeInputModal = function () {
    var _a, _b;
    var _c = useState(false), agreementCodeNotFoundError = _c[0], setAgreementCodeNotFoundError = _c[1];
    var _d = useState(false), isValidInput = _d[0], setIsValidInput = _d[1];
    var _e = useState(false), isLoading = _e[0], setIsLoading = _e[1];
    var _f = useState(false), isDirty = _f[0], setIsDirty = _f[1];
    var _g = useContext(NationalAccountContext), validResponseState = _g.validResponseState, setValidResponseState = _g.setValidResponseState, setShowModal = _g.setShowModal, setErrorState = _g.setErrorState, errorState = _g.errorState, fetchValidateAgreementCode = _g.fetchValidateAgreementCode;
    var _h = useForm({ mode: 'onSubmit' }), register = _h.register, handleSubmit = _h.handleSubmit, formErrors = _h.formState.errors, setValue = _h.setValue, reset = _h.reset;
    var validateString = function (input) {
        var isInvalidCode = !input ||
            input.length === 0 ||
            !input.match(nationalAccountRegex.inputRegex);
        setIsValidInput(!isInvalidCode);
    };
    var handleAgreementCode = function (_a) {
        var currentTarget = _a.currentTarget;
        var value = currentTarget.value;
        validateString(value.toUpperCase());
    };
    var updateAgreementCodeInput = function (_a) {
        var currentTarget = _a.currentTarget;
        var value = currentTarget.value;
        var ain = value === null || value === void 0 ? void 0 : value.toUpperCase();
        if (!isDirty) {
            setIsDirty(true);
        }
        setAgreementCodeNotFoundError(false);
        validateString(ain);
        setErrorState(false);
        setValue('agreementCode', ain);
    };
    var setValidResponse = useCallback(function (data) {
        setValidResponseState({
            requiredEINState: data.einRequired,
            enrollState: false,
            agreementCodeEntered: data.abbreviatedName,
            agreementCodeNameEntered: data.agreementName,
            validatedState: true,
            agreementType: data.agreementType,
            einGovState: data.agreementType === 'GOVERNMENT',
        });
    }, [validResponseState.enrollState]);
    var handleValidateAgreementCode = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var agreementCode, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    agreementCode = data.agreementCode;
                    if (agreementCode.length < 1)
                        return [2 /*return*/];
                    setIsLoading(true);
                    setErrorState(false);
                    return [4 /*yield*/, fetchValidateAgreementCode(agreementCode)];
                case 1:
                    response = _a.sent();
                    setIsLoading(false);
                    if (!response) {
                        setErrorState(true);
                        setIsValidInput(false);
                    }
                    else if (response.hasError) {
                        clickCta('pricing benefits: national account incentives overlay: agreement code invalid');
                        setAgreementCodeNotFoundError((response === null || response === void 0 ? void 0 : response.status) === 404);
                        setIsValidInput(false);
                        setErrorState((response === null || response === void 0 ? void 0 : response.status) === 500);
                        reset();
                    }
                    else if (response.data) {
                        setValidResponse(response.data);
                        setIsValidInput(true);
                        clickCta('pricing benefits: national account incentives overlay: agreement code successful validation');
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var cancelValidation = function () {
        setErrorState(false);
        setShowModal(false);
        setAgreementCodeNotFoundError(false);
        clickCta('pricing benefits: national account incentives overlay: cancel');
        setValidResponseState(function (prevState) {
            return __assign(__assign({}, prevState), { enrollState: true });
        });
        reset();
    };
    return (React.createElement("div", { className: "sui-flex sui-flex-col sui-justify-center sui-align-start sui-font-regular sui-text-1xl" },
        React.createElement("form", { onSubmit: handleSubmit(handleValidateAgreementCode) },
            React.createElement("div", { className: "sui-pt-4" },
                React.createElement("div", { className: "sui-flex sui-flex-col sui-justify-between" },
                    React.createElement("div", { className: "sui-pb-6" }, handleMultiLines(modalBlurbs.enroll.content))),
                isLoading && React.createElement(ShowSpinner, null),
                React.createElement("div", { className: "sui-pt-1 sui-flex sui-flex-row sui-justify-between sui-align-center" },
                    React.createElement("div", { className: "sui-pb-1" }, modalBlurbs.enroll.agreementCode),
                    React.createElement("div", { className: "sui-flex sui-flex-row sui-justify-end" },
                        React.createElement(ToolTip, { label: modalBlurbs.enroll.tooltip })))),
            React.createElement("div", { className: "sui-pt-0 sui-pb-4" },
                React.createElement(TextField, { fullWidth: true, type: "text", id: "agreementCode", autoComplete: "off", error: isDirty &&
                        (!isValidInput ||
                            (agreementCodeNotFoundError &&
                                !!((_a = formErrors.agreementCode) === null || _a === void 0 ? void 0 : _a.message))), helperText: (_b = formErrors.agreementCode) === null || _b === void 0 ? void 0 : _b.message, className: "textAreaAgreement", onChange: updateAgreementCodeInput, onBlur: handleAgreementCode, inputProps: __assign({}, register('agreementCode', {
                        maxLength: 12,
                        minLength: 1,
                        pattern: nationalAccountRegex.inputRegex,
                    })) }),
                isDirty && (agreementCodeNotFoundError || !isValidInput) && (React.createElement("p", { className: "sui-text-danger sui-text-xs", "data-testid": "validationErrorText" }, "Please enter a valid Agreement Code.")),
                errorState && (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "sui-h-6" }),
                    React.createElement(ReturnError, null)))),
            isLoading && React.createElement(ShowSpinner, null),
            React.createElement(ModalButtonGroup, { handleClose: cancelValidation, disabled: !isValidInput, confirmBlurb: modalBlurbs.enroll.buttons.continue, cancelBlurb: shared.cancel }))));
};
